export default __webpack_public_path__ + "static/media/bio.55ad9f8c.svg";